import axios from "../../util/axiosConfig";
export type PortfolioEntry = {
  id: number; title: string; thumbnail: string; result: "YES" | "NO" | "VOID";
  yesQuantity: number; noQuantity: number; yesAverage: number | null; noAverage: number | null; profit: number | null;
};
export type Portfolio = { shareId: string | null; introduction: string; published: boolean; items: PortfolioEntry[]; nickname?: string };
export const portfolioApi = {
  read: (id: string) => axios.get<Portfolio>(`/api/portfolios/${encodeURIComponent(id)}`),
  mine: () => axios.get<Portfolio>("/api/me/portfolio"),
  candidates: () => axios.get<PortfolioEntry[]>("/api/me/portfolio/candidates"),
  save: (introduction: string, published: boolean, marketIds: number[]) => axios.put<Portfolio>("/api/me/portfolio", { introduction, published, marketIds }),
};
